import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './rubik/Rubik-VariableFont_wght.ttf';
import './rubik/Rubik-Italic-VariableFont_wght.ttf';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styleguide.css';
import AuthStateApp from './AuthStateApp';



ReactDOM.render(
    <AuthStateApp/>,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
